function setUsableHeight() {
    let usableHeight;
    if (window.visualViewport) {
        usableHeight = window.visualViewport.height;
    } else {
        usableHeight = window.innerHeight;
    }
    document.documentElement.style.setProperty('--usable-height', `${usableHeight}px`);
}
setUsableHeight();
document.addEventListener('DOMContentLoaded', function () {
    // Top menu
    const topMenuItems = document.querySelectorAll('.ms-drawer-top-menu div');
    topMenuItems.forEach(function (item) {
        item.addEventListener('click', function () {
            const itemType = this.getAttribute('data-item-type');

            topMenuItems.forEach(function (menuItem) {
                menuItem.classList.remove('active');
            });

            this.classList.add('active');

            document.querySelectorAll('.ms-drawer-middle-menu').forEach(function (menu) {
                menu.style.opacity = '0';
                menu.style.display = 'none';
            });

            const targetMenu = document.querySelector(`.ms-drawer-middle-menu[data-item-type="${itemType}"]`);
            if (targetMenu) {
                targetMenu.style.display = 'block';
                // Force reflow before starting animation
                void targetMenu.offsetWidth;
                targetMenu.style.opacity = '1';
            }
        });
    });

    // Middle menu
    const openButtons = document.querySelectorAll('.ms-drawer-middle-primary--open');
    openButtons.forEach(function (button) {
        button.addEventListener('click', function (event) {
            event.preventDefault();
            const nextElement = this.nextElementSibling;
            if (nextElement) {
                if (nextElement.style.display === 'none' || !nextElement.style.display) {
                    nextElement.style.display = 'block';
                    const height = nextElement.scrollHeight;
                    nextElement.style.height = '0';
                    // Trigger reflow
                    void nextElement.offsetWidth;
                    nextElement.style.height = height + 'px';

                    setTimeout(() => {
                        nextElement.style.height = '';
                    }, 500);
                } else {
                    const height = nextElement.scrollHeight;
                    nextElement.style.height = height + 'px';
                    // Trigger reflow
                    void nextElement.offsetWidth;
                    nextElement.style.height = '0';

                    setTimeout(() => {
                        nextElement.style.display = 'none';
                        nextElement.style.height = '';
                    }, 500);
                }
            }
        });
    });
    // Make first menu items initially visible
    const firstMenuItem = document.querySelector('.ms-drawer-top-menu div:first-child');
    if (firstMenuItem) {
        firstMenuItem.click();
    }
    const header = document.querySelector(".header-wrapper"); // Sélection du header

    if (header) {
        let scrollTimeout;
        window.addEventListener("scroll", function () {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(function () {
                let scrollTop = window.scrollY; // Récupère la position du scroll
                let maxScroll = 500; // Distance max pour atteindre 0.5 d'opacité
                let opacity = Math.min((scrollTop / maxScroll) * 0.5, 0.5); // Calcul de l'opacité progressive

                header.style.backgroundColor = `rgba(230, 230, 230, ${opacity.toFixed(2)})`; // Application de l'opacité
            }, 100);
        });
    }
});